import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-button-primary',
  imports: [MatButton],
  templateUrl: './button-primary.html',
  styleUrl: './button-primary.css',
})
export class ButtonPrimary {
  @Input() label: string = 'Confirmar';
  @Input() disabled: boolean = false;
  @Input() type: 'submit' | 'button' = 'button';
  @Input() onClick: () => void = () => {};
  @Input() buttonClass: string = '';
}
